<template lang="pug">
  .filters
      b-form-select.margin(
        ref="techFilter"
        v-if="userRole"
        v-model="filters.tecnico"
        :options="technicianOptions"
        :disabled="loading"
        @change="onTechnicianChange"
      )
  </template>
  <script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { mapState, mapWritableState } from 'pinia'
import { useDashboardStore } from '@/pinia/views/useDashboardStore'

export default {
  name: 'FilterByTechnician',
  data() {
    return {
      userRole: null,
    }
  },

  async created() {
    const { user } = JSON.parse(localStorage.getItem('user'))
    this.userRole = user.groups.find(
      (r) =>
        r.name === 'Gerencia' ||
        r.name === 'Administrativo' ||
        r.name === 'Supervisor'
    )
    await this.loadTechnicians()
  },
  async mounted () {
    await this.filters
    this.filters.tecnico = null
  },

  watch: {
    'filters.tipoServicio': {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadTechnicians()
          this.filters.tecnico = null
        }
      },
    },
  },

  methods: {
    ...mapActions('TechniciansStore', ['listTechnicians']),
    ...mapMutations('OT', ['SET_IS_INITIAL_DATA']),
    async loadTechnicians() {
      try {
        const params = {}
        
        // Filtrar por tipo de servicio si está seleccionado
        if (this.filters.tipoServicio) {
          params.tipo_servicio = this.filters.tipoServicio
        }
        
        await this.listTechnicians({ params, forceReload: true })
      } catch (error) {
        console.error('Error al cargar técnicos:', error)
      }
    },

    async removeFilters() {
      this.filters.tecnico = null
    },
    
    onTechnicianChange() {
      this.SET_IS_INITIAL_DATA(false);
    },
  },

  computed: {
    ...mapGetters('TechniciansStore', ['technicians']),
    ...mapWritableState(useDashboardStore, ['filters', 'loading']),
    ...mapState(useDashboardStore, ['queryParams']),

    technicianOptions() {
      // El backend ya filtra por tipo_servicio, aquí solo filtramos técnicos activos
      const availableTechnicians = this.technicians.filter(t => 
        t.cantidad_ot_garantia > 0 || t.cantidad_ot_presupuesto > 0
      )

      const mappedTechnicians = availableTechnicians.map((t) => {//eslint-disable-line
        const names = `${t.tecnico.first_name} ${t.tecnico.last_name}`
        const garantia = `${t.cantidad_ot_garantia}/${t.cantidad_maxima}G`
        const presupuesto = `${t.cantidad_ot_presupuesto}/${t.cantidad_maxima_presupuesto}P`
        const total = `${t.cantidad_ot_garantia + t.cantidad_ot_presupuesto}/${t.cantidad_maxima_total}T`
        return {
          value: t.tecnico.id,
          text: `${names} (${garantia}) (${presupuesto}) (${total})`, //eslint-disable-line
        }
      }).sort((a, b) => (a.text.toLowerCase() < b.text.toLowerCase()) ? -1 : (a.text.toLowerCase() > b.text.toLowerCase()) ? 1 : 0);
      
      mappedTechnicians.unshift({
        value: null,
        text: 'Todos los Técnicos',
        disabled: false,
      })
      return mappedTechnicians;
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.margin {
  &:not(:last-child) {
    margin-right: 15px;
  }
  @include media-breakpoint-down(md) {
    margin-bottom: 10px;
  }
}
.filters {
  display: flex;
  @include media-breakpoint-down(md) {
    display: block;
  }
}
</style>
